import { FormikTouched } from "formik";
import React, { Fragment, useEffect } from "react";

type FormFieldTouchedCallbackProps = {
    touched: FormikTouched<any>;
    callback: () => void;
};

const FormFieldTouchedCallback = ({
    touched,
    callback,
}: FormFieldTouchedCallbackProps) => {
    if (touched && Object.keys(touched).length > 0) {
        callback && callback();
    }
    return <Fragment />;
};

type FormFieldChangedCallback = {
    value: any;
    callback: (value: any) => void;
};

const FormFieldChangedCallback = ({
    value,
    callback,
}: FormFieldChangedCallback) => {
    useEffect(() => {
        callback && callback(value);
    }, [value]);
    return <Fragment />;
};

export { FormFieldTouchedCallback, FormFieldChangedCallback };
